import { SpaceGroupSelect as UIKitSpaceGroupSelect } from "@circle-react-shared/SpaceGroupSelect";
import { SpaceGroupSelectCompass } from "@circle-react-shared/SpaceGroupSelectCompass";
import type { SpaceGroup } from "@circle-react/types/SpaceGroup";

import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

export interface SpaceGroupSelectProps {
  appendTo?: Element | null;
  containerClassname?: string;
  dropdownClassName?: string;
  layout?: "horizontal" | "vertical";
  name: string;
  onChange?: () => void;
  rules?: Record<string, unknown>;
  shouldShowEmoji?: boolean;
  spaceGroups: SpaceGroup[];
  variant?: "form-input" | "large";
}

export const SpaceGroupSelect = (props: Readonly<SpaceGroupSelectProps>) => {
  const isCircleV4 = useIsCircleV4FeatureEnabled(
    "circle_v4_form_elements_enabled",
  );

  if (!isCircleV4) {
    return <UIKitSpaceGroupSelect {...props} />;
  }

  const { name, rules, onChange, spaceGroups, ...passThrough } = props;

  return (
    <SpaceGroupSelectCompass
      name={name}
      rules={rules}
      onChange={onChange}
      spaceGroups={spaceGroups}
      {...passThrough}
    />
  );
};

SpaceGroupSelect.displayName = "SpaceGroupSelect";
